export default __webpack_public_path__ + "static/media/php.07d33130.png";